import { NgModule } from '@angular/core';

import { AtlasButtonModule } from '@wellsky/atlas-ui/button';
import { AtlasBreadcrumbsModule } from '@wellsky/atlas-ui/breadcrumbs';
import { AtlasCheckboxModule } from '@wellsky/atlas-ui/checkbox';
import { AtlasChipsModule } from '@wellsky/atlas-ui/chips';
import { AtlasFooterModule } from '@wellsky/atlas-ui/ctafooter';
import { AtlasInputModule } from '@wellsky/atlas-ui/input';
import { AtlasRadioModule } from '@wellsky/atlas-ui/radio';
import { AtlasSearchModule } from '@wellsky/atlas-ui/search';
import { AtlasSelectModule } from '@wellsky/atlas-ui/select';
import { AtlasSidenavModule } from '@wellsky/atlas-ui/sidenav';
import { AtlasTabsModule } from '@wellsky/atlas-ui/tabs';
import { AtlasTextareaModule } from '@wellsky/atlas-ui/textarea';
import { AtlasTimepickerModule } from '@wellsky/atlas-ui/timepicker';
import { AtlasTooltipModule } from '@wellsky/atlas-ui/tooltip';
import { AtlasDatepickerModule } from '@wellsky/atlas-ui/datepicker';
import { AtlasMenuModule } from '@wellsky/atlas-ui/menu';
import { AtlasBannersModule } from '@wellsky/atlas-ui/banners';
import { AtlasDialogModule } from '@wellsky/atlas-ui/dialog';
import { AtlasTopNavModule } from '@wellsky/atlas-ui/topnav';
import { AtlasCardModule } from '@wellsky/atlas-ui/card';
import { AtlasSpinnerModule } from '@wellsky/atlas-ui/spinner';
import { AtlasCryptoModule } from '@wellsky/atlas-ui/crypto';

@NgModule({
  imports: [
    AtlasButtonModule,
    AtlasBreadcrumbsModule,
    AtlasCheckboxModule,
    AtlasChipsModule,
    AtlasFooterModule,
    AtlasInputModule,
    AtlasRadioModule,
    AtlasSearchModule,
    AtlasSelectModule,
    AtlasSidenavModule,
    AtlasTabsModule,
    AtlasTextareaModule,
    AtlasTimepickerModule,
    AtlasTooltipModule,
    AtlasDatepickerModule,
    AtlasMenuModule,
    AtlasBannersModule,
    AtlasDialogModule,
    AtlasTopNavModule,
    AtlasCardModule,
    AtlasSpinnerModule,
    AtlasCryptoModule,
  ],
  declarations: [],
  exports: [
    AtlasButtonModule,
    AtlasBreadcrumbsModule,
    AtlasCheckboxModule,
    AtlasChipsModule,
    AtlasFooterModule,
    AtlasInputModule,
    AtlasRadioModule,
    AtlasSearchModule,
    AtlasSelectModule,
    AtlasSidenavModule,
    AtlasTabsModule,
    AtlasTextareaModule,
    AtlasTimepickerModule,
    AtlasTooltipModule,
    AtlasDatepickerModule,
    AtlasMenuModule,
    AtlasBannersModule,
    AtlasDialogModule,
    AtlasTopNavModule,
    AtlasCardModule,
    AtlasSpinnerModule,
    AtlasCryptoModule,
  ]
})
export class AtlasModule { }
